import { IAthenaRateRequest } from '../interfaces/IAthenaRateRequest';

export const adhocContractualRateRequests: IAthenaRateRequest = {
    messageIdentifier: '',
    originCountry: '',
    originCity: '',
    originSite: null,
    placeOfReceipt: '',
    placeOfReceiptSite: null,
    destinationCountry: '',
    destinationCity: '',
    destinationSite: null,
    placeOfDelivery: '',
    placeOfDeliverySite: null,
    portOfLoadingCountry: '',
    portOfLoading: '',
    portOfLoadingSite: null,
    portOfDischarge: '',
    portOfDischargeSite: null,
    portOfDischargeCountry: '',
    emptyContainerReturnedCountry: '',
    emptyContainerReturnedCity: '',
    emptyContainerReturnedSite: null,
    serviceTypeAtOrigin: '',
    serviceTypeAtDestination: '',
    freightPpCollect: '',
    carrierCode: '',
    containerSize: '',
    containerType: '',
    departureDateEstimated: '',
    arrivalDateEstimated: '',
    gateInDate: '',
    deliveryConfirmedDate: '',
    gateInEmptyMoveDate: '',
    cargoReceivingDate: '',
    salesArea: null,
    originalDocumentNumber: null,
    documentType: '',
    invoicee: null,
    shipper: '',
    consignee: '',
    contractualParty: '',
    contractualPartyRole: '',
    cargoType: null,
    specialCargoIndicator: null,
    incoTerm: '',
    primaryTransportMode: '',
    businessCategory: '',
    shipmentTypeAtOrigin: '',
    shipmentTypeAtDestination: '',
    originServiceSubType: null,
    transportContractNumber: null,
    externalIdentifier: null,
    addedCharges: [
        {
            materialCode: '',
            materialDescription: '',
            itemCategory: '',
            quantity: null,
            totalVolume: null,
            totalWeight: null,
            numberOfDays: null,
            palletType: null,
            payToPartyDetails: '',
            itemReference: '',
            unitOfMeasurement: '',
            modeOfTransport: null,
            referenceType: null,
            referenceNumber: null
        }
    ],
};